let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("770kE")).then(() => parcelRequire('aozWl'));